import { render } from "./AddDiscoveryModal1.vue?vue&type=template&id=0a243176&scoped=true"
import script from "./AddDiscoveryModal1.vue?vue&type=script&lang=js"
export * from "./AddDiscoveryModal1.vue?vue&type=script&lang=js"

import "./AddDiscoveryModal1.vue?vue&type=style&index=0&id=0a243176&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a243176"]])

export default __exports__